import LinkButton from 'components/shared/button/LinkButton';
import { useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  setAllMView,
  setSelectedView,
} from '../../../../store/home/homeMyViewSlice';
import {
  setAllInsightView,
  setCards,
  setCustomerInsightBoardId,
  setSelectedInsightView,
} from '../../../../store/customer/customerViewSlice';
import classes from './AddNewView.module.scss';
import {
  ADD_NEW_INSIGHT_VIEW_SUCCESS_MESSAGE,
  CONFIGURE_VIEW,
  VIEW_CATEGORY,
  INSIGHT_TYPE_CODE,
  ADD_FIRST_INSIGHT_VIEW_SUCCESS_MESSAGE,
} from 'constants/constants';
import { ADD_NEW_VIEW_SUCCESS_MESSAGE } from 'constants/constants';
import GNEModal from 'components/shared/modal/Modal';
import { addNewUserView } from '../services/user-view.service';
import { addNewInsightView } from 'store/customer/customer-view-actions';
import {
  buildFilterPayload,
  getAccessibleFilters,
  viewNameValidation,
} from 'utils/utils';
import { useNavigate } from 'react-router-dom';

const AddNewView = ({ openModal, onOpenHandler, page }) => {
  const isMyView = page === CONFIGURE_VIEW.myView ? true : false;
  const isInsights = page === CONFIGURE_VIEW.insights;
  const [title, setTitle] = useState('');
  const [titleError, setTitleError] = useState('');
  const dispatch = useDispatch();
  const allMViews = useSelector((state) => state?.HomeMyView?.allMViews);
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const custInsightsBrdId = useSelector(
    (state) => state?.CustomerView?.custInsightsBrdId
  );
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const focusAccountChecked = useSelector(
    (state) => state.CustomerView?.focusAccountChecked
  );
  const selectedView = useSelector((state) => state.CustomerView?.selectedView);

  const engagementFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );
  const sitePerformanceFilters = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters
  );
  const siteUtilizationFilters = useSelector(
    (state) => state?.CustomerView?.siteUtilizationFilters
  );
  const AffiliationFilter = useSelector(
    (state) => state?.CustomerView?.affiliationsFilters
  );
  const copayAnalyticsFilters = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters
  );
  const productMixFilters = useSelector(
    (state) => state?.CustomerView?.productMixFilters
  );
  const payerMixFilters = useSelector(
    (state) => state.CustomerView?.payerMixFilters
  );
  const policyDetailsFilters = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters
  );
  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const ecosystemOpportunityFilters = useSelector(
    (state) => state.CustomerView?.ecosystemOpportunityFilters
  );

  const navigateTo = useNavigate();

  const onCancel = (event) => {
    event?.preventDefault();
    onOpenHandler(false);
    setTitle('');
    setTitleError('');
  };

  const getFiltersPayload = () => {
    let filters = {
      Engagements: engagementFilters,
      SitePerformance: sitePerformanceFilters,
      SiteUtilization: siteUtilizationFilters,
      Affiliations: AffiliationFilter,
      CopayAnalytics: copayAnalyticsFilters,
      ProductMix: productMixFilters,
      PayerMix: payerMixFilters,
      PolicyDetails: policyDetailsFilters,
      EcosystemOpportunity: ecosystemOpportunityFilters,
    };

    // Get only those filters whose keys are NOT present in componentAccessList
    filters = getAccessibleFilters(filters, componentAccessList, selectedView);

    return buildFilterPayload(filters);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      const payload = {
        name: title,
        type: INSIGHT_TYPE_CODE.GENERAL,
        owner: 'Me',
        category: VIEW_CATEGORY.CREATED,
      };
      const insightPayload = {
        custInsightsBrdId: custInsightsBrdId,
        name: title,
        type: INSIGHT_TYPE_CODE.GENERAL,
        /*
          In Case of ADD NEW VIEW :
          If user is selecting filters before creating view, then send filters
          else don't send if IB and view is already created.
        */
        filters:
          custInsightsBrdId && selectedInsightView?.Id
            ? undefined
            : getFiltersPayload(),
      };

      const boardpayload = {
        name: `${selectedCustomer?.label}`,
        customerId: selectedCustomer?.value,
        custInsightsBrdId: null,
        isPriorityAccount: focusAccountChecked === true ? 'Y' : 'N',
        cardsData: [],
        boardType: selectedView,
      };

      let viewId;

      if (isMyView) {
        const response = await addNewUserView(payload);
        viewId = response?.result?.Id;
        dispatch(setSelectedView(response?.result));
        dispatch(setAllMView([response?.result, ...allMViews]));
        navigateTo(`/view/${'myview'}/${viewId}`);
        toast.success(ADD_NEW_VIEW_SUCCESS_MESSAGE);
      } else if (isInsights) {
        const response = await addNewInsightView(insightPayload, boardpayload);
        if (!custInsightsBrdId && response?.custInsightsBrdId) {
          dispatch(setCustomerInsightBoardId(response?.custInsightsBrdId));
          toast.success(ADD_FIRST_INSIGHT_VIEW_SUCCESS_MESSAGE);
        } else {
          toast.success(ADD_NEW_INSIGHT_VIEW_SUCCESS_MESSAGE);
        }
        dispatch(setSelectedInsightView(response));
        dispatch(setAllInsightView([response, ...(allInsightViews || [])]));
        dispatch(setCards([]));
      }

      onOpenHandler(false);
      setTitle('');
      setTitleError('');
    }
  };

  const handleTitleChange = (e) => {
    const value = e.target.value;
    const view = viewNameValidation(value);
    setTitle(view?.name);
    setTitleError(view?.errMsg);
  };

  const content = (
    <>
      <p className='d-flex align-items-center gap-1 ms-3'>
        <i className='icon icon__addTitle lg me-1 mb-1' />
        <span className='text text__text-medium text__bold'>Add New View</span>
      </p>

      {isInsights && (
        <p className='d-flex align-items-center gap-1 ms-3 me-4'>
          <span className='text text__text-small '>
            Creating a view is the first step in building an Insight board,
            enabling you to save tiles and filters across different sections for
            easy access later. Once you create at least one view, a customer
            Insight board is automatically generated (Note: Insight tiles are
            not yet enabled for Payer View.)
          </span>
        </p>
      )}

      <Form
        className='mx-3'
        noValidate
        onSubmit={handleSubmit}>
        <div>
          <Form.Group
            as={Col}
            controlId='validationCustom01'>
            <Form.Label className='text text__small'>Title</Form.Label>
            <Form.Control
              required
              type='text'
              value={title}
              onChange={handleTitleChange}
              autoComplete='off'
              isInvalid={titleError?.length > 0}
              isValid={title?.length > 0 && titleError?.length === 0}
              maxLength={129}
            />
            <Form.Control.Feedback
              className='animate__animated animate__pulse w-100'
              type='invalid'>
              <div className='d-flex justify-content-between'>
                <span>{titleError}</span> <span>{title?.length} / 128 </span>
              </div>
            </Form.Control.Feedback>
          </Form.Group>
          {!titleError && (
            <span className=' w-100 d-flex justify-content-end'>
              {title?.length} / 128
            </span>
          )}
        </div>
        <div className='d-flex justify-content-end mt-4 mb-2'>
          <LinkButton
            onClick={onCancel}
            className='text text__small  me-2'>
            Cancel
          </LinkButton>
          <Button
            variant='btn btn-gne btn-primary'
            type='submit'
            className={` ${classes['btn-add']}`}
            disabled={!title?.length || titleError?.length > 0}>
            Save
          </Button>
        </div>
      </Form>
    </>
  );

  return (
    <>
      {openModal && (
        <GNEModal
          show={openModal}
          onHide={onCancel}
          content={content}
          css='size-medium'
        />
      )}
    </>
  );
};

export default AddNewView;
